// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"7db76a0b","400":"3055e1cd"}[chunkId] + ".chunk.css";
};